import Logger from '@tcp-base/toolkit';
import { create } from 'zustand';

export interface NavbarMenuCollapseState {
  isCollapsed: boolean;
  setIsCollapsed: () => Promise<void>;
  getIsCollapsed: () => Promise<boolean>;
}

export const useNavbarMenuCollapseStore = create<NavbarMenuCollapseState>((set, get) => ({
  isCollapsed: false,
  setIsCollapsed: async (): Promise<void> => {
    try {
      set({ isCollapsed: !get().isCollapsed });
    } catch (error) {
      Logger.error('Failed to save navbar menu collapse state:', error);
      throw error;
    }
  },
  getIsCollapsed: async (): Promise<boolean> => {
    const { isCollapsed } = get();
    return isCollapsed;
  },
}));
